import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  resource: 'task',
  operation: 'getMany',
  returnAll: false,
  limit: 50,
  completed: false,
  isHtml: false,
  userGid: 'me',
};

export default defaults;
